import React, { useEffect, useState } from 'react';
import "./NbhdContentHeader.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers/root";
import { useTranslation } from "react-i18next";
import AmpInlineLoadingSpinner from '../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner';
import { downloadPOIReport, getPOIList } from '../../../redux/actions/nbhd/nbhd';
import { DownloadPOIReportState } from '../../../redux/reducers/getNBHDReducer/getDownloadPOIReportReducer';
export interface headerProp {
    handleViewChange: (e) => void;
    reportLoading: boolean;
  }

export default function HEADER(props: headerProp) {
    const currentProperty = useSelector((state: RootState) => state.propertyListReducer.currentProperty);
    const userProfileId = window.localStorage.getItem("userProfileId");

    const SnapshotsList = useSelector((state: RootState) => state.SnapshotsListReducer.SnapshotsList);
    const loading: boolean = SnapshotsList['loading'];
    const snapshots: Record<string, unknown> = SnapshotsList["poiListDetail"];

    const { t, i18n } = useTranslation(["nbhd"]);
    const dispatch = useDispatch();
    const [openDownloadDropdown, setOpenDownloadDropdown] = useState(false);

    const downloadPOIReportState = useSelector((state: RootState) => state.NBHDReducer.DownloadPOIReport as DownloadPOIReportState);

    const countSnaps = () => {
        let counter = 0;
        const snaps = snapshots ? snapshots["snapshots"] as string : "";
        if (snaps) {
            counter = (snapshots["snapshots"] as Array<Record<string, unknown>>).filter(snap => (snap['type'] === "POI" && snap['reported'] === 1)).length;
        }
        return <>{counter}</>
    }

    const showPOIView = (e) => {
        if (!props.reportLoading) {
            props.handleViewChange("ViewPOI");
        } 
        
    }

    const showDownloadDropdown = (e) => {
        if (loading) {
            return false;
        }
        setOpenDownloadDropdown(openDownloadDropdown => !openDownloadDropdown);
    }

    const downloadPOI = (is_pdf: boolean) => {
        const pois = (snapshots["snapshots"] as Array<Record<string, unknown>>).filter(snap => (snap['type'] === "POI" && snap['reported'] === 1));
        const poi_rolls = [];
        pois.forEach((poi) => {
            poi_rolls.push(poi["roll"]);
        });
        const new_pois = (snapshots["snapshots"] as Array<Record<string, unknown>>).filter(snap => (snap['type'] === "POI" && snap['newpoi'] === 1));
        const new_pois_rolls = [];
        new_pois.forEach((poi) => {
            new_pois_rolls.push(poi["roll"]);
        });
        const payload = {
            "user": userProfileId,
            "lang": i18n.language,
            "roll": currentProperty["currentProperty"],
            // "pois": poi_rolls,
            "new_pois": new_pois_rolls,
            "is_pdf": is_pdf,
            "owner_type": currentProperty["currentOwnerType"]
        }
        dispatch(downloadPOIReport(payload));
        // return false;
    }

    useEffect(() => {
        if (downloadPOIReportState.file != null) {
            dispatch(getPOIList(userProfileId, currentProperty["currentProperty"], currentProperty["currentOwnerType"]));
            const file = downloadPOIReportState.file;
            let url = null;
            if (file.type === "text/html") {
                const fileblob = new Blob([file.content], { type: file.type });
                url = URL.createObjectURL(fileblob);
            } else {
                url = `data:${file.type};base64,${file.content}`;
            }
            const a = document.createElement("a");
            a.href = url;
            a.download = file.name;
            a.click();
            downloadPOIReportState.file = null;
        }
    }, [downloadPOIReportState, dispatch, userProfileId, currentProperty]);

    return (<>
        <div className="right-container-header">
            <div className="right-container-header-tab-container" onClick={(e) => showPOIView(e)}>
                <div className="neighbourhood-tab-header-container">
                    <div className="neighbourhood-tab-icon-container">
                        <img className="ampv4-img-esm-neighbourhood" src="images/FavouritesReport.png" alt=''></img>
                    </div>

                    <div className="neighbourhood-tab-text-container">
                        <span>
                            <div>
                                <span>{t("nbhd.Map-Nav.report-1")}</span>
                            </div>

                            <div className="bottom-fav-count-header">
                                <span>{t("nbhd.Map-Nav.report-2")}</span>
                                <span>
                                    <FontAwesomeIcon className="header-heart" icon={faHeart} />
                                </span>
                                <span>{loading ? <AmpInlineLoadingSpinner /> : countSnaps()}/24</span>
                            </div>
                        </span>
                    </div>

                </div>
            </div>
            <div className="right-container-header-tab-container" onClick={(e) => showDownloadDropdown(e)}>
                <div className="neighbourhood-tab-header-container">
                    <div className="neighbourhood-tab-icon-container">
                        <img className="ampv4-img-esm-neighbourhood" src="images/Download.png" alt=''></img>
                    </div>
                    <div className="neighbourhood-tab-text-container">
                        <span>
                            <div>
                                <span>{t("nbhd.Map-Nav.report-3")}</span>
                            </div>
                            <div>
                                <span>{t("nbhd.Map-Nav.report-2")} {downloadPOIReportState.loading && <AmpInlineLoadingSpinner/>}</span>
                            </div>
                        </span>
                    </div>
                </div>
                <div className={openDownloadDropdown ? "open" : ""}>
                    <div className='dropdown-menu'>
                        <div>
                            <a className='dropdownLink center' onClick={(e) => {e.preventDefault();downloadPOI(true);}} href={0}>
                                <img src="/images/pdf.png" alt=""></img>
                                PDF
                            </a>
                        </div>
                        <div>
                            <a className='dropdownLink center' onClick={(e) => {e.preventDefault();downloadPOI(false);}} href={0}>
                                <img src="/images/html.png" alt=""></img>
                                HTML
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="right-container-header-tab-container snap-heading">
                <div className="neighbourhood-tab-header-container">
                    <div className="neighbourhood-tab-icon-container">
                        <img className="ampv4-img-esm-neighbourhood" src="images/SnapshotViews.png" alt=''></img>
                    </div>
                    <div className="neighbourhood-tab-text-container-2">
                        <span>
                            <div>
                                <span>{loading ? <AmpInlineLoadingSpinner /> : (snapshots ? snapshots['count'] as number : "0")}/100</span>
                            </div>
                            <div>
                                <span>{t("nbhd.Map-Nav.snap-1")}</span>
                            </div>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </>);
}